import { cn } from '@/app/lib';

interface AccordionEmptyStateProps {
  className?: string;
}

export function AccordionEmptyState({ className }: AccordionEmptyStateProps) {
  return (
    <div className={cn('text-center text-gray-500 py-8', className)}>
      <p>No accordion items available</p>
      <p className="text-sm mt-2">Debug: items array is empty or undefined</p>
    </div>
  );
}
